module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfiBxQIAimElKenAAAAp0lEQVRYw+2Wuw2AMAxEDxpK6gzAGOzAFgzBJizBDozBANSUVISGjxKlQvaBhN8A96Rw2AYMw/g7DoNeeIYWC7xWfIURHl5HUKDDesQrCGpMV7i4oESPLYgXFTSYo3BBgcOQCBcSnIVUEtyFVBCEhRQXxIUUFaQKKShIF/KRIH9rECs/EeEjU2pK+NEoo4Iw7CjjmrJwCCuTsvQJZwvl8CKcjoZhfIcdk5YdssI2B0gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Screens/Dashboard/baseline_previous_arrow_black_24dp.png
// module id = 126
// module chunks = 0